import api from '../../apiConfig/apiConfig.js'
import { Get, Post } from '../base/baseAjax'

let inquiryFilterStat = (param) => {
  return Post({
    url: api.garbageInquiry.inquiryFilterStat,
    bodyParam: param,
  })
}
let addFilterRule = (param) => {
  return Post({
    url: api.garbageInquiry.addFilterRule,
    bodyParam: param,
  })
}
let deleteFilterRule = (param) => {
  return Get({
    url: api.garbageInquiry.deleteFilterRule,
    PathParam: param,
  })
}

export default {
  inquiryFilterStat,
  addFilterRule,
  deleteFilterRule,
}
